import {Marker} from '@react-google-maps/api';
import PropTypes from 'prop-types';
import {pathOr} from 'ramda';
import React from 'react';
import {getPosition} from '../utils/map';

export const defaultIcon = {
  url: '/assets/maps-marker.png',
  scaledSize: {
    width: 32,
    height: 45,
  },
};

export const downtime1Icon = {
  ...defaultIcon,
  url: '/assets/maps-marker-downtime-1.png',
};

export const downtime2Icon = {
  ...defaultIcon,
  url: '/assets/maps-marker-downtime-2.png',
};

export const circleIcon = {
  get path () {
    // This needs to be a getter because this object is created before the google maps script is loaded
    // 0 is used as a fallback because that's the value of window.google.maps.SymbolPath.CIRCLE at the time of writing
    return pathOr(0, ['google', 'maps', 'SymbolPath', 'CIRCLE'], window);
  },
  strokeColor: '#fff',
  strokeOpacity: 1,
  strokeWeight: 2,
  scale: 26,
  fillColor: '#fff',
  fillOpacity: 0.35,
};

const MapMarker = ({location, ...props}) => (
  <Marker
    position={getPosition(location)}
    icon={defaultIcon}
    {...props}
  />
);

MapMarker.propTypes = {
  location: PropTypes.shape({
    latitude: PropTypes.number.isRequired,
    longitude: PropTypes.number.isRequired,
  }).isRequired,
};

export default MapMarker;
